export default "__VITE_ASSET__DTDk2gpK__"